"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockHelpers = exports.IndexHelpers = exports.mapIndexToProfileList = exports.keyDays = exports.keyIds = exports.isAdmin = void 0;
const Memberships_1 = require("../../../ProfileRequests/Types/Memberships");
const Utils_1 = require("../../../Utils");
const IndexApiProfileRequestTypes_1 = require("../../Types/IndexApiProfileRequestTypes");
const Channels_1 = require("./Channels");
const Loads_1 = require("./Loads");
const Schedules_1 = require("./Schedules");
const TypeUtils = __importStar(require("./TypeUtils"));
const Groups_1 = require("./Groups");
function isAdmin(sub, profile) {
    const membershipsOfProfile = profile.memberships;
    for (const mem of Object.keys(membershipsOfProfile)) {
        if (mem === sub) {
            return membershipsOfProfile[mem].role === Memberships_1.APIUserRole.Admin;
        }
    }
    return false;
}
exports.isAdmin = isAdmin;
const keyIds = (deviceIds) => {
    const keyedIds = {};
    deviceIds === null || deviceIds === void 0 ? void 0 : deviceIds.forEach((id) => {
        keyedIds[id] = 1;
    });
    return keyedIds;
};
exports.keyIds = keyIds;
const keyDays = (days) => {
    if (days === undefined) {
        return undefined;
    }
    const keyedDays = {};
    days.forEach((d) => {
        keyedDays[d] = 1;
    });
    return keyedDays;
};
exports.keyDays = keyDays;
function mapIndexToProfileList(index) {
    return Object.values(index.profiles).map((p) => ({
        uuid: (0, Utils_1.convertIdToUUID)(p.id),
        name: p.name,
    }));
}
exports.mapIndexToProfileList = mapIndexToProfileList;
const findLoadFromDeviceId = (deviceId, loads) => loads.find((l) => deviceId === l.primary_device_id
    || (deviceId && l.switches.indexOf(deviceId) > -1)
    || (l.deviceType === IndexApiProfileRequestTypes_1.IndexAPIDeviceType.PLUG && l.deviceId === deviceId));
const parseTOSVersion = (version) => Number.parseInt(version, 10);
exports.IndexHelpers = Object.assign({ isDeviceBridge: (device) => { var _a; return ((_a = device.deviceId) === null || _a === void 0 ? void 0 : _a.startsWith("bridge")) || false; }, anyDeviceHasConnected: (devices) => devices.some((d) => d.lastCheckinTime !== 0), hasGen2OnProfile: (devices) => devices.some((d) => d.type === IndexApiProfileRequestTypes_1.IndexAPIThingType.V2), hasGen2LoadsOnProfile: (devices) => devices.some((d) => d.isGen2), mapActuatorsAndDevices: Loads_1.mapActuatorsAndDevices,
    mapGroups: Groups_1.mapGroups,
    keyIds: exports.keyIds,
    convertOcelotDaysToIndexDays: Schedules_1.convertOcelotDaysToIndexDays,
    convertScheduleFrameToAPIScheduleFrame: Schedules_1.convertScheduleFrameToAPIScheduleFrame,
    getTimeFromCloudSched: Schedules_1.getTimeFromCloudSched,
    convertIndexDaysToOcelotDays: Schedules_1.convertIndexDaysToOcelotDays,
    mapSchedules: Schedules_1.mapSchedules,
    convertPlugDeviceId: Loads_1.convertPlugDeviceId,
    mapIndexToProfileList,
    findLoadFromDeviceId,
    calculateEditChannelArgs: Channels_1.calculateEditChannelArgs,
    cleanChannelName: Channels_1.cleanChannelName,
    parseChannel: Channels_1.parseChannel,
    createScheduleFromAPI: Schedules_1.createScheduleFromAPI,
    isAdmin,
    getNextSunsetSunriseTimeLocal: Schedules_1.getNextSunsetSunriseTimeLocal,
    parseTOSVersion }, TypeUtils);
exports.MockHelpers = {
    keyDays: exports.keyDays,
    keyIds: exports.keyIds,
};
//# sourceMappingURL=index.js.map